module.exports = __webpack_public_path__ + "img/img25.ea52eb59.svg";